module.exports = __webpack_public_path__ + "static/img/oil_and_person.abea2152.png";